import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button } from "react-md/lib/Buttons";
import DropdownMenu from "react-dd-menu";

class DateFilterMenu extends Component {
  constructor() {
    super();
    this.click = this.click.bind(this);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      isMenuOpen: false
    };
  }

  componentWillUnmount(){
    this.toggle = () => {};
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.toggle();
  }

  click(e) {
    this.props.onChange({
      term: "date",
      title: e.currentTarget.innerText,
      code: e.currentTarget.id,
      id: ""
    });
    this.close();
  }

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: <Button raised onClick={this.toggle} iconBefore={false} iconChildren="filter_list">{this.props.title}</Button>,
      align: "left",
    };

    return (
      <DropdownMenu {...menuOptions}>
        <li><a href="#" id="today" onClick={this.click}>Today</a></li>
        <li><a href="#" id="yesterday" onClick={this.click}>Yesterday</a></li>
        <li><a href="#" id="last7" onClick={this.click}>Last 7 Days</a></li>
        <li><a href="#" id="last30" onClick={this.click}>Last 30 Days</a></li>
        <li><a href="#" id="last60" onClick={this.click}>Last 60 Days</a></li>
        <li><a href="#" id="last90" onClick={this.click}>Last 90 Days</a></li>
        <li><a href="#" id="over3" onClick={this.click}>Over 3 Days Old</a></li>
        <li><a href="#" id="over7" onClick={this.click}>Over 7 Days Old</a></li>
        <li><a href="#" id="over30" onClick={this.click}>Over 30 Days Old</a></li>
        <li><a href="#" id="over60" onClick={this.click}>Over 60 Days Old</a></li>
      </DropdownMenu>
    );
  }
}

DateFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default DateFilterMenu;